<div class="ltms-outbox-multi-request-container">
    <!-- multi request tab -->
    <!-- checkbox -->
    <div class="d-flex justify-content-between gap-5 mb-3">
        <div class="exclude-checkbox-container">
            <label class="d-flex align-items-center gap-2 mb-2">
                <input type="checkbox" [(ngModel)]="fileUploadVm.isExcludedFromAnalytics" style="display: none;"/>
                <div class="checkbox-container">
                    <img *ngIf="!fileUploadVm.isExcludedFromAnalytics" src="assets/images/checkbox-blank-outline.svg" />
                    <img *ngIf="fileUploadVm.isExcludedFromAnalytics" src="assets/images/checkbox-marked.svg" />            
                </div>
                Exclude from statistics
            </label>
    
            <span class="lable-below-text">
                Enabling this will exclude the responses from the Summary count.
            </span>
        </div>
        <div>
            <button class="upload-history-btn" (click)="showUploadHistory()">View upload history</button>
            <button class="upload-history-btn" style="margin-left: 12px;" (click)="showAfpConfig()">View AFP config</button>
        </div>
        
    </div>

    <!-- Touchpoints -->
    <div class="d-flex flex-column gap-1 mb-3">
        <label class="lable-up-text">Touchpoint</label>
        <div class="dropdown-container" [ngClass]="{ 'disabled': isMappingDropdownDisabled}">
            <!-- Input Field with Keyup Event and Clear Button -->
             <!-- {{isTouchpointDropdownOpen}} -->
            <div class="input-container" (click)="toggleDropdown('touchpoint')">
                <input type="text" class="dropdown-input" [(ngModel)]="touchpointSearchText"
                    (keyup)="getTouchpointByKey($event)"
                    placeholder="Enter touchpoint name" />
                <button *ngIf="touchpointSearchText.length" class="clear-btn" (click)="clearTouchpointText()"><img
                        src="assets/images/close.svg"></button>
            </div>

            <img class="dropdown-arrow" [ngClass]="{'rotate-180': isTouchpointDropdownOpen}" src="assets/images/menu-down-dark.svg"
                alt="Dropdown Icon" (click)="toggleDropdown('touchpoint')" />

            <!-- Options Dropdown -->
            <div class="dropdown-content" *ngIf="isTouchpointDropdownOpen && !touchpointSearchText">
                <div class="dropdown-item dropdown-placeholder-item">
                    Select from the list or start by typing something
                </div>
            </div>
            <div class="dropdown-content" *ngIf="isTouchpointDropdownOpen && touchpointOptions.length > 0">
                <div class="dropdown-item" *ngFor="let option of touchpointOptions" (click)="selectTouchpoint(option)">
                    {{ option?.name }}
                </div>
            </div>
        </div>
    </div>





    <!-- file upload -->
    <div class="file-upload-container mb-3">
        <label for="fileUpload" class="lable-up-text">Select file</label>
        <div class="file-instruction-label">
            <span style="opacity: 0.7;">Select a file (*.csv, *.xlsx). Sample file </span>
            <a class="file-instruction-label-link"
                href="https://static1.litmusworld.com/feedback-request-sample-v2.csv">here</a>
        </div>
        <!-- Custom file upload container -->
        <div class="file-uploader-container" [ngClass]="{ 'disabled': this.fileUploadVm?.fileToUpload && showPreview}">
            <label for="file-upload" class="file-uploader-label">Choose File</label>
            <div class="file-uploader" >
                <input type="file" id="file-upload" accept=".csv, .xls, .xlsx" (change)="onFileSelect($event)">
                <span class="file-name">{{ fileName || 'No file chosen' }}</span>
            </div>

            <button (click)="loadParsedFile()" class="add-button" [ngClass]="{
                'btn-default': !fileUploadVm.fileToUpload,  
                'btn-selected': fileUploadVm.fileToUpload
              }">Add</button>
        </div>
    </div>

    <!-- File Preview Section -->
    <div *ngIf="fileName && showPreview" class="file-preview-container">
        <span>{{ fileName }}</span>
        <img class="file-delete" src="assets/images/trash-can-outline.svg" (click)="deleteFile()" />
    </div>
    <div class="file-mapping-container" [ngClass]="{'hidden': !showPreview}">
        <div class="ltms-tabs lato-bold-dark">
            <div class="ltms-tab" id="existingMappingBtn"
                [ngClass]="{ 'ltms-active-tab': activeTab === 'existing_file_mapping', 'disabled-tab': !fileUploadVm.isExistingMapping  }">
                File mapping </div>
            <div class="ltms-tab" id="newMappingBtn"
                [ngClass]="{ 'ltms-active-tab': activeTab === 'new_file_mapping','disabled-tab': fileUploadVm.isExistingMapping  }">
                New mapping</div>
        </div>
        <div class="file-mapping-content-container">
            <!-- <button class="upload-history-btn" (click)="showUploadHistory()">Upload history</button> -->
            <!-- file map content -->
            <div *ngIf="activeTab === 'existing_file_mapping'" class="file-mapping-content">
                <div class="lable-below-text mb-2">Select an existing file mapping template or go to New Mapping</div>
                <!-- dp data from "afp_configs" api  -->

                <!-- file mapping -->
                <div class="d-flex flex-column gap-1 mb-3">
                    <!-- File Mapping Dropdown -->

                    <div class="dropdown-container" [ngClass]="{ 'disabled': isMappingDropdownDisabled}">
                        <input type="text" class="dropdown-input"
                            [value]="selectedFileMapping?.label || 'Select a file mapping'"
                            (click)="toggleDropdown('fileMapping')" readonly />
                        <img class="dropdown-arrow" src="assets/images/menu-down-dark.svg" alt="Dropdown Icon"
                            (click)="toggleDropdown('fileMapping')" />

                        <!-- Options -->
                        <div class="dropdown-content" *ngIf="isFileMappingDropdownOpen">
                            <div class="dropdown-item" *ngFor="let option of fileMapConfig"
                                (click)="selectFileMapping(option?.value)"
                                [ngClass]="{ 'selected': selectedFileMapping?.value === option.value }">
                                {{ option.label }}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!--new  file map content -->
            <div *ngIf="activeTab === 'new_file_mapping'" class="new-file-mapping-content">
                <div class="lable-below-text">Select LitmusWorld Field to Map to -  <br>
                    *Mandatory Fields • Customer ID or Phone Number or Email ID or WhatsApp Number
                </div>
                <!--  -->

                <div>
                    <!-- mapping name -->
                    <div class="d-flex flex-column">
                        <label class="ltms-std-req-map-label">Mapping name<span
                                class="ltms-std-req-asterisk"></span></label>
                        <input type="text" id="configName" class="mapping-name" name="configName" [ngClass]="{'invalid-input': !isValidConfigName}"
                            [(ngModel)]="fileUploadVm.newConfigName" (ngModelChange)="validateMappingName()" placeholder="e.g. New Mapping" autocomplete="off">
                        <span class="invalid-msg" *ngIf="!isValidConfigName">Provide a valid config name</span>
                    </div>
                    <!-- header filed -->
                    <div id="headersList" class="ltms-std-req-map-well">
                        <!-- dynamic mapping fileds -->
                        <div *ngFor="let header of fileUploadVm.fileData.fileHeaders; let i = index">
                            <div>
                                <div class="">
                                    <label class="ltms-std-req-map-label">{{ header }}</label>
                                </div>
                                <div *ngIf="fileUploadVm.headerSelect[header] === 'userPhone' || fileUploadVm.headerSelect[header] === 'userPhone-int'"
                                    class="whatsapp-checkbox">
                                    <label for="same_as_wa">
                                        <div class="checkbox-container">
                                            <input type="checkbox" id="same_as_wa" [(ngModel)]="fileUploadVm.isWhatsappSameAsPhone"
                                            (ngModelChange)="updateMappingDropdownOptions('same_whatsapp_number')" style="display: none;">
                                            <img *ngIf="!fileUploadVm.isWhatsappSameAsPhone" src="assets/images/checkbox-blank-outline.svg" />
                                            <img *ngIf="fileUploadVm.isWhatsappSameAsPhone" src="assets/images/checkbox-marked.svg" />
                                        </div>
                                        <span class="checkbox-ml-10">Same number for WhatsApp</span>
                                    </label>
                                    
                                    <!-- <label for="same_as_wa" style="margin-left: 10px;">Same number for WhatsApp</label> -->
                                </div>
                                <div style="position: relative;">
                                    <select class="form-control ltms-std-req-dropdown" [attr.name]="'mappingListDropdown_' + header"
                                        [(ngModel)]="fileUploadVm.headerSelect[header]" (ngModelChange)="updateMappingDropdownOptions(header)"
                                        [disabled]="header === fileUploadVm.weightage_field" (blur)="onDropdownBlur(header)"
                                        (click)="onDropdownClick(header)">
                                        <option value="" selected disabled hidden>Choose an option</option>
                                        <option *ngFor="let option of fileUploadVm.currentMappingOptions; let j = index" [value]="option.id"
                                            [attr.title]="option.tooltip" [attr.disabled]="option.disabled ? true : null">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                    <img class="dropdown-arrow mapping-dd-arrow" [ngClass]="{'rotate-180': isDropdownOpen(header)}"
                                        src="assets/images/menu-down-dark.svg" alt="Dropdown Icon" />
                                </div>
                                
                                <span class="errorMsgSpan font-sm text-danger"></span>
                            </div>
                        </div>
                    </div>




                </div>
            </div>
            <!-- Modal -->
            <div class="modal modal-dialog-centered" *ngIf="showModal" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content login-pop-up-field">
                        <div class="modal-header">
                            <span class="modal-title login-pop-up-header">{{modalHeader}}</span>
                        </div>
                        <div class="modal-body login-pop-up-summary">{{modalBody}}</div>
                        <div class="modal-footer">
                            <button type="button" class="proceed-config-btn" (click)="confirmAction()">Proceed</button>
                            <button type="button" class="cancel-config-btn" (click)="abortAction()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="form-footer">
        <button class="cancel-btn" (click)="cancelRequest()">Cancel</button>
        <button class="trigger-btn" [ngClass]="{ 'valid': isFormValid }" (click)="triggerRequest()">Trigger
            request</button>
    </div>
    <div class="upload-history-container" [ngClass]="{ 'visible': isUploadHistoryVisible }">
        <div class="upload-history">
            <button class="upload-history-close-btn" (click)="closeUploadHistory()">
                <img src="assets/images/close.svg">
            </button>
            <app-outbox-multi-request-upload-history></app-outbox-multi-request-upload-history>
        </div>
    </div>
    <div class="upload-history-container" [ngClass]="{ 'visible': isAfpConfigVisible }">
        <div class="upload-history">
            <button class="upload-history-close-btn" (click)="closeAfpConfig()">
                <img src="assets/images/close.svg">
            </button>
            <app-outbox-afp-configuration [brandId]="brandId" (deleted)="getAFPConfigs()"></app-outbox-afp-configuration>
        </div>
    </div>
</div>